import { MenuItemType } from '@/Enums';
import { PagesRouting } from '@/Routing';

const MENU_ITEMS_VISIBILITY_MAP: Record<string, Partial<{ [key in MenuItemType]: boolean }>> = {
  [PagesRouting.MainPages.SalesPage.Sales]: {
    [MenuItemType.AssignOrderNumber]: true,
    [MenuItemType.AssignDeliveryNoteNumber]: true,
    [MenuItemType.AssignInvoiceNumber]: true,
    [MenuItemType.AssignCancelInvoiceNumber]: true,
    [MenuItemType.ChangePaymentStatus]: true,
    [MenuItemType.ChangeDeliveryStatus]: true,
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
    [MenuItemType.SplitOrders]: true,
    [MenuItemType.OrderMerge]: true,
    [MenuItemType.ShippingLabel]: true,
    [MenuItemType.CreateFeedback]: true,
    [MenuItemType.ShippingLabel]: true,
    [MenuItemType.ChangeOtherStatuses]: true,
  },
  [PagesRouting.MainPages.PurchasesPage]: {
    [MenuItemType.AssignOrderNumber]: true,
    [MenuItemType.ChangePaymentStatus]: true,
    [MenuItemType.ChangeDeliveryStatus]: true,
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
    [MenuItemType.ShippingLabel]: true,
    [MenuItemType.CreateFeedback]: true,
    [MenuItemType.ShippingLabel]: true,
    [MenuItemType.ChangeOtherStatuses]: true,
  },
  [PagesRouting.MainPages.LogisticsPage.Logistics]: {
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
    [MenuItemType.ShippingLabel]: true,
  },
  [PagesRouting.MainPages.MessagesPage]: {},
  [PagesRouting.MainPages.SuppliersPage.Suppliers]: {
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
  },
  [PagesRouting.MainPages.WarehousePage.Warehouse]: {
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
  },
  [PagesRouting.MainPages.LogisticsPage.Logistics]: {
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
  },
  [PagesRouting.MainPages.CustomersPage.Customers]: {
    [MenuItemType.Document]: true,
    [MenuItemType.Email]: true,
  },
  [PagesRouting.SettingsPages.Settings]: {},
};

export function isMenuItemVisible(pathName: string, menuItemType: MenuItemType): boolean {
  if (MENU_ITEMS_VISIBILITY_MAP[pathName]) {
    const pathMenuItems = MENU_ITEMS_VISIBILITY_MAP[pathName];
    return Boolean(pathMenuItems[menuItemType]);
  }
  return false;
}
